import { DimensionTypes } from '../entities/Dashboard';
import { Kpi } from '../entities/Kpi';
import { DashboardService } from '../services/DashboardService';

/**
 * KPIドメインオブジェクトを生成するFactory
 */
export class KpiFactory {
  /**
   * Kpiオブジェクトを生成する
   * @param initialData - 初期値（不足項目はデフォルトで補完）
   */
  public static create = (initialData: Partial<Kpi> = {}): Kpi => {
    const res: Kpi = {
      metricType:
        initialData.metricType && DashboardService.isMetricType(initialData.metricType) ? initialData.metricType : 'METRIC_UNKNOWN',
      kpiValue: initialData.kpiValue ?? 0,
      valid_from: initialData.valid_from,
      valid_to: initialData.valid_to,
      isCurrent: initialData.isCurrent,
      dimensions: (initialData.dimensions ?? []).map((d) => ({
        dimensionType: DashboardService.isDimensionType(d.dimensionType) ? d.dimensionType : DimensionTypes.UNKNOWN,
        dimensionValue: d.dimensionValue,
      })),
    };
    return res;
  };
}
